// graph/users/mutations.js
import { gql } from "graphql-request";

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      firstName
      lastName
      email
      hourlyRate
      verifiedEmail
      role
      tenantID
      contactID
      notes
      invitedBy
      createdAt
    }
  }
`;


export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      firstName
      lastName
      email
      hourlyRate
      verifiedEmail
      role
      tenantID
      notes
      invitedBy
      updatedAt
      archivedAt
    }
  }
`;


export const DELETE_USER = gql`
  mutation DeleteUser($email: String!) {
    deleteUser(email: $email)
  }
`;


export const ARCHIVE_USER = gql`
  mutation ArchiveUser($id: ID!) {
    archiveUser(id: $id)
  }
`;